import { useMutation } from '@tanstack/react-query'
import { setPassword } from '../services/auth_service';

const useSetPassword = () => {
 const setPasswordMutation = useMutation({
    mutationFn: ({ token, password, confirmPassword }) => setPassword(token, password, confirmPassword),
    onSuccess: (data) => {
    },
    onError: (error) => {
        console.error('Error sending reset password email:', error);
    }
 });
 
 return setPasswordMutation;
}

export default useSetPassword; 